<template>
  <div class="noData" v-bind="{...$attrs}">
    <img src="@/assets/img/wuxinxi.svg" alt="" srcset="">
    <p style="text-align: center;">{{msgFilger}}</p>
  </div>
</template>
<script>
  
  export default {
    name: "noData",
    props: {
      msg: {
        type: String,
        default: ''
      }
    },
    computed: {
      msgFilger() {
        return this.msg || this.$t('noData')
      }
    }
  }
</script>
<style scoped="scoped">

</style>
